const Open_Close_Footer = ({open,handleClick,footerFifthSection}) =>{
    return(
        <>
            <button
          className="table mx-auto w-[6rem] h-[3rem] lg:w-[10vw] lg:h-[5vw] rounded-t-full uppercase text-center bg-[#2a2a2a] border-[#58585a] border-solid border border-b-0 relative z-[6]"
          onClick={handleClick}
        >
          <svg
            className={`d-table mx-auto ${open ? "rotate-180" : "rotate-0"}`}
            width="16"
            height="16"
            fill="#DBDBDB"
            viewBox="0 0 16 16"
          >
            <path d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
          </svg>
          {open ? "Close" : "Open"}
        </button>

        <div
          className={`bg-[#2a2a2a] container text-center border-t-[1px] border-[#58585a] relative z-[5] mt-[-1px] overflow-hidden  ${open ? "max-h-[999px]" : "max-h-[0px]"
            }`}
        >
          {footerFifthSection?.toggle_text && <div
            className="py-5 text-center"
            dangerouslySetInnerHTML={{ __html: footerFifthSection.toggle_text }}
          ></div>}
        </div>
        </>
    )
}

export default Open_Close_Footer;